import styles from '../style/projects.module.css';
import { publicAsset } from '../utils/publicAsset';

export default function ProjectCard({ project, language, ui }) {
  const synopsisKey = `synopsis${language.toUpperCase()}`;
  const categoryKey = `category${language.toUpperCase()}`;
  const imageAltKey = `imageAlt${language.toUpperCase()}`;
  const alt = project[imageAltKey] || project.title;
  const siteAria = project.siteCta === 'app' ? ui.openApp : ui.openSite;

  return (
    <article className={ `${styles.compact} ${styles.cardElevated}` }>
      <div className={ styles.compactMedia }>
        <img
          src={ publicAsset(project.image) }
          alt={ alt }
          className={ styles.compactImage }
          loading="lazy"
        />
        <div className={ styles.compactScrim } aria-hidden="true" />
        <span className={ styles.compactCategory }>{project[categoryKey]}</span>
      </div>
      <div className={ styles.compactBody }>
        <h2 className={ styles.compactTitle }>{project.title}</h2>
        <p className={ styles.compactDescription }>{project[synopsisKey]}</p>
        <div className={ styles.techCloud }>
          {project.technologies.map((technology) => (
            <span key={ technology } className={ styles.techChipMuted }>
              {technology}
            </span>
          ))}
        </div>
        <div className={ styles.compactLinks }>
          {project.github && (
            <a
              href={ project.github }
              target="_blank"
              rel="noreferrer"
              aria-label={ ui.viewCode }
            >
              <img src={ publicAsset('/github_gray.svg') } alt="" className={ styles.iconLink } />
            </a>
          )}
          {project.site && (
            <a
              href={ project.site }
              target="_blank"
              rel="noreferrer"
              aria-label={ siteAria }
            >
              <img src={ publicAsset('/icon_site.svg') } alt="" className={ styles.iconLink } />
            </a>
          )}
        </div>
      </div>
    </article>
  );
}
